import { createSlice } from "@reduxjs/toolkit";
import { fetchVoteDetailsAsync } from "../actions/anketAction";

const initialState = {
  voteDetails: null,
  loading: false,
  error: null,
};

export const anketSlice = createSlice({
  name: "anket",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchVoteDetailsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVoteDetailsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.voteDetails = action.payload;
      })
      .addCase(fetchVoteDetailsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const anketReducer = anketSlice.reducer;
export default anketReducer;
